import VerifyOtp from './VerifyOtp';
import React, { useState } from 'react';
import UpdatePassword from './UpdatePassword';
import { Link, useLocation, useParams } from 'react-router-dom';

const ResetPassword = () => {
  const location = useLocation();
  const { email } = useParams();
  const decodedEmail = decodeURIComponent(email);
  const [verified, setVerified] = useState(null);

  return (
    <>
      <div className="">
        <div className="flex-1 py-6 px-5 flex flex-col items-start  lg:pl-36">
          <div className="w-full flex justify-center lg:justify-end">
            <Link to="/" aria-label="SmallSmall Home">
              <img
                src="/images/SST_LOGO_HORIZONTAL_WEB_DARK.svg"
                alt="SmallSmall Logo"
                width={120}
                height={40}
                loading="eager"
                decoding="defer"
              />
            </Link>
          </div>
        </div>
        <section className="px-5 md:w-[480px] mx-auto grid gap-3">
          <h1 className="font-semibold text-[29px] font-duplet">
            Reset password
          </h1>
          <p className="font-xs text-balance text-[#96959F]">
            Enter the code sent to{' '}
            <span className="text-black">{decodedEmail}</span> to reset your
            password.
          </p>
          <VerifyOtp
            verified={verified}
            setVerified={setVerified}
            email={decodedEmail}
          />
          <hr />
          <UpdatePassword
            email={decodedEmail}
            verified={verified}
            setVerified={setVerified}
            disabled={verified !== true}
          />
        </section>
      </div>
    </>
  );
};

export default ResetPassword;
